<div class="container">
  <p-multiSelect
    [filter]="true"
    [ngClass]="{ 'ng-invalid ng-dirty': shouldShowError }"
    [options]="center$ | async"
    [(ngModel)]="selectedCenters"
    (ngModelChange)="selectedCentersChanged()"
    optionValue="centroId"
    selectedItemsLabel="{{ 'USERS.SELECTED_CENTERS' | translate }}"
    optionLabel="centroName"
    [ngStyle]="{'min-width': '193px'}"
  >
  </p-multiSelect>

  <!--LAbel -->
  <label>{{ "USERS.SELECT_DEFAULT_CENTER"| translate }}</label>
  <div>
    <p-dropdown
      [filter]="true"
      class="wide-dropdown"
      [ngClass]="{ 'ng-invalid ng-dirty': shouldShowError }"
      [options]="selectedCentersObjects"
      [(ngModel)]="defaultCenter"
      optionValue="centroId"
      optionLabel="centroName"
      (ngModelChange)="selectedCentersChanged()"
      placeholder="{{ 'USERS.SELECT_DEFAULT_CENTER' | translate }}"
    >
    </p-dropdown>
  </div>
</div>
